export default "__VITE_ASSET__ddf97373__"